import PropTypes from "prop-types"
import React, { memo } from "react"
import { Button } from "atomize"
import { theme } from "../settings/config"

SecondaryButton.propTypes = {
    action: PropTypes.func,
    disabled: PropTypes.bool,
    h: PropTypes.string,
    m: PropTypes.string,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    textColor: PropTypes.string,
    textSize: PropTypes.string,
    textWeight: PropTypes.string,
}

SecondaryButton.defaultProps = {
    m: "auto",
    h: "3.5rem",
    text: null,
    textSize: "body",
    textColor: "text_alt",
    action: null,
    textWeight: null,
    disabled: false,
}

function SecondaryButton({ m, h, textSize, textColor, textWeight, action, text, disabled }) {
    return (
        <Button
            className="btn-secondary"
            m={m}
            p="0"
            h={h}
            bg="transparent"
            /*
                Il bottone è trasparente, ma da disabilitato atomize gli mette
                addosso il suo grigio pieno: in mezzo a una scheda bianca
                sembra un errore. Da spento resta trasparente e sbiadisce solo
                il testo.
            */
            disableBg="transparent"
            disableBorderColor="transparent"
            disableColor="text_light"
            w="fit-content"
            textSize={textSize}
            textColor={disabled ? theme.colors.text_light : textColor}
            textWeight={textWeight}
            onClick={action}
            disabled={disabled}
        >
            {text}
        </Button>
    )
}

export default memo(SecondaryButton)
